module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAKBAMAAAB293L0AAAAFVBMVEUAAAAeHh4ZGRkZGRkaGhoZGRkZGRl8F4bKAAAAB3RSTlMAETNmd7vMoX/W0gAAADZJREFUCNdjYAADEQjFGAShRRUg3BQGBkEgLebAwGAmAOYysCSCuQwMboIpYEUsaQ4QTcYgAgCSEARngcm/dQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/static/img/checked.png
// module id = 32
// module chunks = 0